import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { getData } from '../../services/fetch-service';

function SocialLinks(props) {
    const { shape, className, locale } = props;
    const [socialLinks, setSocialLinks] = useState([]);
    useEffect(() => {
        getData(`Home/GetSocialNetworks?Gjuha=${locale}&Layout=default`).then((response) => {
            setSocialLinks(response.data);
        })
    }, []);

    const classes = classNames(className, 'social-links', {
        'social-links--shape--circle': shape === 'circle',
        'social-links--shape--rounded': shape === 'rounded',
    });
    const items = socialLinks.map((item, key) => (
        <li key={key} className="social-links__item">
            {item.html !== '' && item.html !== null ? (
                <a
                    className={`social-links__link social-links__link--type--${item.emertimi}`}
                    href={item.linku}
                    target="_blank"
                    name="link"
                    aria-label="link"
                    rel="noopener noreferrer"
                >
                    <i className={item.html} />
                </a>
            ) : (
                <a
                    className={`social-links__link social-links__link--type--${item.emertimi}`}
                    href={item.linku}
                    target="_blank"
                    name="link"
                    aria-label="link"
                    rel="noopener noreferrer"
                >
                    <img src={`${item.imgPath}`} alt="" width="34px" height="34px" />
                </a>
            )}
        </li>
    ));

    return (
        <div className={classes}>
            <ul className="social-links__list">
                {items}
            </ul>
        </div>
    );
}

SocialLinks.propTypes = {
    shape: PropTypes.oneOf(['circle', 'rounded']),
    className: PropTypes.string,
};
SocialLinks.defaultProps = {
    shape: null,
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(SocialLinks);
